import { Component, OnInit } from '@angular/core';
import { ExpressService } from '../services/express.service';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-express-details',
  templateUrl: './express-details.component.html',
  styleUrls: ['./express-details.component.scss']
})
export class ExpressDetailsComponent implements OnInit {
  public accessRoles: any;
  public uuid:string='';
  public expressDetails:any={};
  public quoteObj:any = [];
  // public selectedVersion:string='';
  // public isContractSigned:boolean = false;
  // public isValidContract:boolean = false;
  // public isDiscard:boolean = false;
  // public isSharedWithClient:boolean = false;
  constructor(
    public expressService: ExpressService,
    private notifier:NotifierService,
    private router: Router,
    private activaterRoute:ActivatedRoute,
    private dialog: MatDialog
  ) { 
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    // this.expressService.onContractDetailsReload
    //   .subscribe(() => {
    //     // this.selectedVersion = '';
    //     console.log("onContractDetailsReload",this.selectedVersion);
    //     this.getExpressDetails();
    //   })
  }

  ngOnInit(): void {
    this.expressService.isSearchShow = false;
    this.getExpressDetails();
  }

  getExpressDetails(){
    this.expressService.getExpressDetails(this.uuid).subscribe((result) => {
      if (result["status"] == 1) {
        this.expressDetails = result['data'];
        this.expressService.eid = result["eid"];
        // this.isContractSigned = result['signed'] ? result['signed'] : false;
        // this.isValidContract = result['is_valid_form'] ? result['is_valid_form'] : false;
        // this.isSharedWithClient = result['shared_with_client'] ? result['shared_with_client'] : false;
        // this.expressService.contractVersionList = result['versions'].map((item) => item +'');
        // this.isDiscard = result["discard"] ? result["discard"] : false;
        // this.selectedVersion = this.selectedVersion && this.selectedVersion !="" ? this.selectedVersion : result['versions'][0] +'';
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })
  }

 
backToExpressList(){
    this.router.navigate(['/express']);
  }
  

}
